import { useMutation } from 'react-query';
import { gql } from 'graphql-request';
import { graphQLClient } from './setup';
import { User, useUsersQuery } from './UsersQuery';

const QUERY = gql`
  mutation removeUser($_id: ID) {
    removeUser(_id: $_id)
  }
`;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useDeleteUser = (): any => {
  const { refetch } = useUsersQuery();

  return useMutation<User, Error>(
    'user',
    async (_id) => {
      const data = await graphQLClient.request(QUERY, _id);
      return data;
    },
    {
      onSuccess: () => {
        refetch();
      },
    }
  );
};
